import { DragOverlay } from '@dnd-kit/core'

function DndOverlay({ children, ...restProps }) {
  return <DragOverlay {...restProps}>{children}</DragOverlay>
}

export default DndOverlay
